import React, { Suspense, lazy, memo } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import PrivateRoute from './Routes/PrivateRoute';
import './App.css';

// 1. Carga perezosa (Lazy Imports)
const Land = lazy(() => import("./components/land"));
const Login = lazy(() => import("./screens/Login.jsx"));
const Stats = lazy(() => import("./components/blog.js"));
const StatsTest = lazy(() => import("./components/blog2.js"));
const AddUser = lazy(() => import("./screens/Private copy.jsx"));
const DashBoard = lazy(() => import("./components/Category.jsx"));
const Carrera = lazy(() => import("./components/carreras.js"));
const Cursos = lazy(() => import("./components/Capacitaciones.js"));
const Articulos = lazy(() => import("./components/Capacitaciones copy.js"));
const Museo = lazy(() => import("./components/Capacitaciones copy 2.js"));
const Foro = lazy(() => import("./components/ForoESFA.js"));
const Video = lazy(() => import("./components/Video.js"));
const Tramite = lazy(() => import("./components/Tramite.js"));
const Theme = lazy(() => import("./components/Theme.js"));
const Test = lazy(() => import("./components/taskUser.js"));
const Curses = lazy(() => import("./components/Curses.js"));
const Tests = lazy(() => import("./components/Tests"));
const Private = lazy(() => import("./screens/Private.jsx"));

const Model = lazy(() => import("./components/ww2 copy.js"));
const Landwww = lazy(() => import("./components/land copy 2.js"));
const AudioPlayer = lazy(() => import("./components/componenteswww.js"));

// Estilos de carga centralizados
const pageStyle = {
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  height: '100vh',
  width: '100vw',
  backgroundColor: '#f8f9fa'
};

// Pantalla de carga memorizada
const Loading = memo(() => (
  <div style={pageStyle}>
    <div className="text-center p-3">
      <div className="d-flex align-items-center justify-content-center gap-2 mt-2">
        <div className="spinner-border spinner-border-sm text-info" role="status" />
        <span className="fw-semibold text-secondary fs-6">Cargando página...</span>
      </div>
    </div>
  </div>
));

export default function App() {
  return (
    <BrowserRouter>
      {/* Suspense global para captura de rutas lazy */}
      <Suspense fallback={<Loading />}>
        <Routes>
          {/* Rutas Públicas */}
          <Route path="/" element={<Land />} />
          <Route path="/login" element={<Login />} />
          <Route path="/stats" element={<Stats />} />
          <Route path="/statest/:tipo/:email" element={<StatsTest />} />
          <Route path="/carpeta" element={<DashBoard />} />
          <Route path="/carreras" element={<Carrera />} />
          <Route path="/cursos" element={<Cursos />} />
          <Route path="/foro" element={<Foro />} />
          <Route path="/tramites" element={<Tramite />} />
          <Route path="/video/:www" element={<Video />} />
          <Route path="/articulos" element={<Articulos />} />
          <Route path="/museo" element={<Museo />} />
          <Route path="/objetivos" element={<Model />} />
          <Route path="/documentos" element={<Landwww />} />
          <Route path="/hires" element={<AudioPlayer />} />

          {/* Rutas Privadas Agrupadas */}
          <Route element={<PrivateRoute />}>
            <Route path="/adduser" element={<AddUser />} />
            <Route path="/theme/:theme/:curse" element={<Theme />} />
            <Route path="/test/:idtheme/:codetheme" element={<Test />} />
            <Route path="/curso/:id" element={<Curses />} />
            <Route path="/private" element={<Private />} />
            <Route path="/test/:idtest" element={<Tests />} />
          </Route>
        </Routes>
      </Suspense>
    </BrowserRouter>
  );
}